var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownV3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.402 8.41.652 1.66C.301 1.344.301.816.652.465c.317-.317.844-.317 1.196 0L8 6.652 14.152.5c.317-.352.844-.352 1.196 0a.83.83 0 0 1 0 1.16L8.562 8.41a.77.77 0 0 1-1.16 0"
})));
export default SvgArrowDownV3;